export const ACEITAR_PROCESSO = "ACEITAR_PROCESSO";
export const LISTAR_PROCESSOS_PRODUTIVOS_DISPONIVEIS =
  "LISTAR_PROCESSOS_PRODUTIVOS_DISPONIVEIS";
export const CRIAR_PROCESSO_PRODUTIVO = "CRIAR_PROCESSO";
export const EDITAR_PROCESSO_PRODUTIVO = "EDITAR_PROCESSO";
export const EXCLUIR_PROCESSO_PRODUTIVO = "EXCLUIR_PROCESSO_PRODUTIVO";
export const LISTAR_PROCESSO_PRODUTIVO = "LISTAR_PROCESSO_PRODUTIVO";
export const RECUSAR_PROCESSO_PRODUTIVO = "RECUSAR_PROCESSO_PRODUTIVO";
